import { PropsWithChildren, createContext, useEffect, useState } from "react";
import HttpClient from "../../utils/http";
import Session from "../../utils/session";
import Loading from "../../components/loading/loading";
import { useFeedback } from "../feedback/feeedback";
import { useNavigate } from "react-router-dom";
import useUser from "../user/user_provider";
import { localServiceBaseUrls } from "../../config";

// const HttpContext = createContext();

export function HttpProvider({ children }: PropsWithChildren) {
  const { accessToken } = useUser();
  const { showSnackbar } = useFeedback();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    HttpClient.interceptors.request.clear();
    HttpClient.interceptors.response.clear();
    HttpClient.interceptors.request.use(
      function (config) {
        const requestUrl = config.url || "";
        if (!/^https?:\/\//i.test(requestUrl)) {
          const normalizedUrl = requestUrl.replace(/^\/+/, "");
          const matchPrefix = Object.keys(localServiceBaseUrls)
            .sort((a, b) => b.length - a.length)
            .find((prefix) => normalizedUrl.startsWith(prefix));

          if (matchPrefix) {
            config.baseURL = localServiceBaseUrls[matchPrefix];
          }
        }

        const token = accessToken || Session.getToken();
        if (token && token !== "null" && token !== "undefined") {
          config.headers.Authorization = `Bearer ${token}`;
        } else if (
          config.headers.Authorization === "Bearer null" ||
          config.headers.Authorization === "Bearer undefined"
        ) {
          delete config.headers.Authorization;
        }

        if (!config.headers["locale"]) {
          config.headers["locale"] = "en";
        }

        // Which of this email's own org accounts is active this session —
        // only meaningful when the same email is a portal-user account of
        // more than one org (see useUser().switchOrg). The backend uses it
        // only to disambiguate among that same email's own accounts, never
        // to grant access to a different identity.
        const activeOrgId = Session.getActiveOrgId();
        if (activeOrgId) {
          config.headers["x-active-org-id"] = String(activeOrgId);
        }

        return config;
      },
      function (error) {
        return Promise.reject(error);
      }
    );

    HttpClient.interceptors.response.use(
      function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger

        return response;
      },
      function (error) {
        const status = error?.response?.status;
        if (status === 446) {
          showSnackbar("Session timed out, Please relogin");
          sessionStorage.clear();
          localStorage.clear();
          window.location.pathname = "/";
          // } else if (error.response.status === 436) {
          // window.location.pathname = "/access-disabled";
        } else if (status === 401 && (accessToken || Session.getToken())) {
          // A 401 on an authenticated request means the JWT has expired (or
          // been superseded) — anything unauthenticated, like the merchant
          // OTP login flow, never had a token to begin with, so is left alone.
          showSnackbar("Login Session expired");
          sessionStorage.clear();
          localStorage.clear();
          window.location.pathname = "/";
        }
        // Any status codes that falls outside the range of 2xx cause this function to trigger

        return Promise.reject(error);
      }
    );
    setInitialized(true);
  }, [accessToken, showSnackbar]);

  return <>{initialized ? children : null}</>;
}
